import React from 'react';
import './App.css';
import Form from "./components/user_input_form";

function App() {
  return (
    <div className="App">
        <Form />
    </div>
  );
}

export default App;